import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Nursery/English";
import { Helmet } from "react-helmet";

const English: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery - English Language"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Discover engaging English language activities for nursery kids on Mamas Guidance—featuring letter recognition, phonics, vocabulary building, and fun literacy exercises to support early language development.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default English;